export default "__VITE_ASSET__fb9ac098__"